import React from 'react';

function About() {
  return (
    <div>
      <h1>this page is under devolopment now</h1>
    </div>
  )
}

export default About
